export enum UrlRoutes {
  Dashboard = "/dashboard",
  Departments = "/departments",
  Employees = "/employees",
  Login = "/login",
  Logout = "/logout",
  Organization = "/organization",
  Rotations = "/rotations",
  RotationDisplay = "/display/rotation",
  Schedules = "/schedules",
}

export enum UrlPaths {
  Dashboard = "dashboard",
  Departments = "departments",
  Employees = "employees",
  Login = "login",
  Logout = "logout",
  Organization = "organization",
  Rotations = "rotations",
  RotationDisplay = "display/rotation",
}
